export class DrawerItemSubtitle {
  public formatterPipe: any;
  public formatterPipeArgs: any[];
  public subTitleName: string;

  constructor(public dataSubtitleField: string) {}
}
